import React from "react";

// STYLES
import * as Style from "./EventCardStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";

// MISC
import { IProps } from "./EventCardModel";

// ASSETS

// REDUX

// COMPONENTS

const EventCard = (props: IProps) => {

  // PROPS
  const {
    eventDetails = {
      title: "",
      description: "",
      startDate: "",
      endDate: "",
      id: "",
      photoUrl: "",
    },
    slashBar = false,
    height = "",
    hasDescription = false,
  } = props;

  // CONSTANTS USING LIBRARIES
  const navigate = useNavigate();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigate = () => {
    if (eventDetails.id) {
      navigate(`/event/${eventDetails?.id}`);
    };
  };

  return (
    <Style.EventCardContainer
      onClick={handleNavigate}
      photoUrl={eventDetails?.photoUrl || ""}
    >
      <Style.EventDetailsContainer height={height && height}>
        <Style.Title>{eventDetails?.title || ""}</Style.Title>
        {hasDescription && (
          <Style.Description>{eventDetails?.description || ""}</Style.Description>
        )}
        <Style.DatesContainer>
          <Style.DateContainer>{eventDetails?.startDate || ""}</Style.DateContainer>
          {slashBar && <Style.SlashBar>/</Style.SlashBar>}
          <Style.DateContainer>{eventDetails?.endDate || ""}</Style.DateContainer>
        </Style.DatesContainer>
      </Style.EventDetailsContainer>
    </Style.EventCardContainer>
  );
};

export default EventCard;
